import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { Inject } from '../helpers';
import { UserService } from './userService';
import { EmailSettingMutationInput, EmailSettingMutationPayload } from '../../schema';

// `errors` was not selected, so a rejected mutation came back as a perfectly
// ordinary 200 with id: null -- and the client reported "Saved Successfully!"
// regardless. Ask for the errors so the caller can tell the difference.
const mutation = `
mutation createEmailSettions(
  $input: EmailSettingMutationInput!
){
  createEmailSetting(
    input: $input
  ){
    id
    errors {
      field
      messages
    }
  }
}
`;

export class EmailService {
  static instance: EmailService;

  @Inject userService: UserService;

  constructor() {
    if (EmailService.instance) {
      return EmailService.instance;
    } else {
      EmailService.instance = this;
    }
  }

  add(data: EmailSettingMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    Api.graphql<{ input: EmailSettingMutationInput }, EmailSettingMutationPayload>(
      API_URL,
      { input: { ...data } },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
